import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const createNewBranchOperation = async (
  branchName: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (branchName.length < 3 || branchName.length > 19) {
      toast.warn('על שם השלוחה להיות בין 3 ל20 תווים בלבד');
    }
    const existingBranch = globalSettingsBranches.branches.find(
      (item) => item.branchName === branchName,
    );
    if (existingBranch) {
      toast.warn('קיים שם שלוחה');
      return;
    }
    setLoading(true);

    const createBranchRes = await appApi.addBranch(branchName);
    globalSettingsBranches.branches.push(createBranchRes.data.body);
    setLoading(false);
    closeDialog();
    // TODO API call
    // TODO save in the local state
  } catch (e) {
    toast.error(`לא ניתן לבצע את הפעולה נסה שוב בעוד מספר רגעים`);
    setLoading(false);
  }
};
